<template>
  <v-form
    lazy-validation
    v-model="valid"
    @submit.prevent="submit"
    ref="form"
  >
      <v-container class="text-center">
        <v-row>
          <v-col cols="2">
            <v-text-field
              filled
              type="Number"
              data-cy="FormOrgTarget-targetJanuary"
              label="January"
              v-model="localOrgTarget.targetJanuary"
            />
          </v-col>
          <v-col cols="2">
            <v-text-field
              filled
              type="Number"
              data-cy="FormOrgTarget-targetFebruary"
              label="February"
              v-model="localOrgTarget.targetFebruary"
            />
          </v-col>
          <v-col cols="2">
            <v-text-field
              filled
              type="Number"
              data-cy="FormOrgTarget-targetMarch"
              label="March"
              v-model="localOrgTarget.targetMarch"
            />
          </v-col>
          <v-col cols="2">
            <v-text-field
              filled
              type="Number"
              data-cy="FormOrgTarget-targetApril"
              label="April"
              v-model="localOrgTarget.targetApril"
            />
          </v-col>
          <v-col cols="2">
            <v-text-field
              filled
              type="Number"
              data-cy="FormOrgTarget-targetMay"
              label="May"
              v-model="localOrgTarget.targetMay"
            />
          </v-col>
          <v-col cols="2">
            <v-text-field
              filled
              type="Number"
              data-cy="FormOrgTarget-targetJune"
              label="June"
              v-model="localOrgTarget.targetJune"
            />
          </v-col>
          <v-col cols="2">
            <v-text-field
              filled
              type="Number"
              data-cy="FormOrgTarget-targetJuly"
              label="July"
              v-model="localOrgTarget.targetJuly"
            />
          </v-col>
          <v-col cols="2">
            <v-text-field
              filled
              type="Number"
              data-cy="FormOrgTarget-targetAugust"
              label="August"
              v-model="localOrgTarget.targetAugust"
            />
          </v-col>
          <v-col cols="2">
            <v-text-field
              filled
              type="Number"
              data-cy="FormOrgTarget-targetSeptember"
              label="September"
              v-model="localOrgTarget.targetSeptember"
            />
          </v-col>
          <v-col cols="2">
            <v-text-field
              filled
              type="Number"
              data-cy="FormOrgTarget-targetOctober"
              label="October"
              v-model="localOrgTarget.targetOctober"
            />
          </v-col>
          <v-col cols="2">
            <v-text-field
              filled
              type="Number"
              data-cy="FormOrgTarget-targetNovember"
              label="November"
              v-model="localOrgTarget.targetNovember"
            />
          </v-col>
          <v-col cols="2">
            <v-text-field
              filled
              type="Number"
              data-cy="FormOrgTarget-targetDecember"
              label="December"
              v-model="localOrgTarget.targetDecember"
            />
          </v-col>
        </v-row>
        <div class="d-flex justify-end mb-6">
          <v-btn color="default" outlined class="ml-4 btn-cancel" @click="cancel"
            data-cy="FormOrgTarget-button-cancel">
            {{ $t('common.buttons.cancel') }}
          </v-btn>
          <v-btn color="primary" type="submit" class="ml-4" :loading="isSaving"
            data-cy="FormOrgTarget-button-save">
              {{ $t('common.buttons.save') }}
            </v-btn>
        </div>
      </v-container>
  </v-form>
</template>

<script>
import loading from '@codehq/aurora-app-core/src/mixins/loading';

export default {
  name: 'FormOrgTarget',
  module: 'Quote',
  mixins: [loading],
  props: {
    /**
    * Set the text box value. Default: undefined,
    */
    OrgTarget: {
      type: Object,
      default: undefined,
    },
  },
  data() {
    return {
      /**
      * Hold form validation state
      */
      valid: false,
      /**
      * Local value used for property localOrgTarget
      */
      localOrgTarget: {},
    };
  },
  watch: {
    OrgTarget() {
      this.localOrgTarget = this.OrgTarget;
    },
  },
  created() {
    this.localOrgTarget = this.OrgTarget;
  },
  methods: {
    /** Submit Form data trigger
     * @event save
     * @type {object}
     */
    submit() {
      // validate
      if (this.$refs.form.validate()) {
        this.$emit('save', this.localOrgTarget);
        this.isSaving = true;
      }
    },
    /** Cancel form trigger
     * @event cancel
     */
    cancel() {
      this.$emit('cancel');
    },
  },
};
</script>

<docs>
# FormOrgTarget example

'''js
<FormOrgTarget :OrgTarget="OrgTarget" />
'''
</docs>
